import './SingleValueRenderer.css';
export var chartStateHandler = '_utn1m52-3-5-0';
export var singleValueContainer = '_utn1m50-3-5-0';
export var singleValueInnerContainer = '_utn1m51-3-5-0';
export var sparklineArea = '_utn1m53-3-5-0';
export var trendArea = '_utn1m54-3-5-0';